import React from 'react';
import DataPoller from 'components/ui/DataPoller';
import LocationActionCreators from 'actions/LocationActionCreators';
import LocationStore from 'stores/LocationStore';
import Details from 'components/modules/locations/Details';
export default class Module extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    getStateFromStore() {
        const location = LocationStore.getLocation();
        this.setState({ location });
    }
    componentDidMount() {
        LocationStore.addChangeListener(() => this.getStateFromStore());
    }
    render() {
        return (React.createElement("div", null,
            React.createElement(DataPoller, { action: () => LocationActionCreators.getLocation(this.props.match.params.id) }),
            React.createElement(Details, { location: this.state.location })));
    }
}
